import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import store from '@/store/store';
import router from '@/router/router';

const HTTP = axios.create();

HTTP.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    config.headers.Accept = 'application/json, text/plain, */*';

    // If its a login request, don't include a bearer token
    if (config.url && config.url.includes('/auth/login')) {
      return config;
    }

    const token = store.getters['auth/authToken'];

    if (token != null) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

HTTP.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  (error: any) => {
    if (error.response.status === 401) {
      const message = error.response.data.error.message;
      if (message && message === 'jwt expired') {
        store.dispatch('auth/refresh').catch(error => {
          store.dispatch('auth/logout');
          router.push('/login');
        });
      }

      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

export { HTTP };
